import Axios from "axios";
import AiSettings, {OrganizationAiSettings} from "../domain/AiSettings";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";

class AiSettingsService {

    readonly basePath = "/ai-settings";

    public get(): Promise<AiSettings> {
        return Axios.get(this.basePath)
            .then(value => AiSettings.fromPOJO(value.data));
    }

    public update(settings: AiSettings): Promise<void> {
        return Axios.put(this.basePath, this.toUpdatePayload(settings));
    }

    public getOrganizations(queryOptions: QueryOptions): Promise<PagedResult<OrganizationAiSettings>> {
        return Axios.get(`${this.basePath}/organizations?${queryOptions.toQueryParams()}`)
            .then(value => {
                const objectList = value.data.data.map((objectJson: object) => OrganizationAiSettings.fromPOJO(objectJson));

                return new PagedResult(value.data.total, objectList);
            });
    }

    public getOrganization(organizationId: string): Promise<OrganizationAiSettings> {
        return Axios.get(`${this.basePath}/organizations/${organizationId}`)
            .then(value => OrganizationAiSettings.fromPOJO(value.data));
    }

    public updateOrganization(organizationId: string, settings: AiSettings): Promise<void> {
        return Axios.put(`${this.basePath}/organizations/${organizationId}`, this.toUpdatePayload(settings));
    }

    private toUpdatePayload(settings: AiSettings) {
        return {
            autoRunSystemAiExtractorsOnOrganizationSources: settings.autoRunSystemAiExtractorsOnOrganizationSources
        };
    }
}

export default AiSettingsService;
